import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Eignungstest } from '../models/eignungstest.model';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { tap, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Activity } from '../models/activity.model';
import { EignungstestInvitation } from '../models/eignungstestInvitation';

@Injectable({
  providedIn: 'root',
})
export class EignungstestService {
  private apiUrl = environment.apiUrl + '/eignungstest';

  constructor(private http: HttpClient) {}

  getAllTests(): Observable<Eignungstest[]> {
    return this.http.get<Eignungstest[]>(this.apiUrl);
  }

  getTestById(testId: number): Observable<Eignungstest> {
    return this.http.get<Eignungstest>(`${this.apiUrl}/${testId}`);
  }
  createTest(test: Eignungstest): Observable<Eignungstest> {
    return this.http.post<Eignungstest>(`${this.apiUrl}/create`, test);
  }

  updateTest(test: Eignungstest): Observable<Eignungstest> {
    return this.http.put<Eignungstest>(`${this.apiUrl}/${test.testId}`, test);
  }

  deleteTest(testId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${testId}`);
  }

  sendTestResultEmail(testId: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/${testId}/send-result-email`, {});
  }

  uploadPdfToMinio(testId: number, file: File): Observable<string> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<string>(
      `${this.apiUrl}/uploadPdf/${testId}`,
      formData
    );
  }

  /* sendTestInvitationEmail(userId: number, emailText: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/sendTestInvitationEmail`, {
      userId,
      emailText,
    });
  }*/

  sendTestInvitationEmail(testId: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/${testId}/send-invitation-email`, {});
  }

  generateTestResultPdf(testId: number): Observable<string> {
    return this.http
      .post<{ pdfUrl: string }>(`${this.apiUrl}/generatePdf/${testId}`, {})
      .pipe(map((res) => res.pdfUrl));
  }

  getTestInvitationLink(userId: number): Observable<string> {
    return this.http.get<string>(
      `${this.apiUrl}/getTestInvitationLink/${userId}`
    );
  }

  saveEignungstest(newTest: Eignungstest): Observable<Activity> {
    return this.http.post<Activity>(`/api/eignungstest`, newTest);
  }
  generatePdfAndUpload(testId: number, pdfFile: File): Observable<string> {
    const formData = new FormData();
    formData.append('file', pdfFile);

    return this.http.post(`${this.apiUrl}/uploadPdf/${testId}`, formData, {
      responseType: 'text',
    });
  }

  sendCreateAndSendInvitation(
    invitation: EignungstestInvitation
  ): Observable<EignungstestInvitation> {
    return this.http.post<any>(
      `${environment.apiUrl}/EignungstestInvitation/CreateAndSendInvitation`,
      invitation
    );
  }
}
